import styled from 'styled-components';
import { c } from 'utils/theme-helpers';

const Title = styled.h1`
  color: ${c('primary')};
`;

export default Title;
